module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "cmip6-tas.839f7e42.png";